import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import { menuCreator } from '../module/menuCreator';
export const store = new Vuex.Store({
    state: {
        //==============================================  
        groups: [],
        navbarmenu: [],
        sliders: [],
        blogs: [],
        amazingOffers: [],
        promoSectionProducts: [],
        brands: [],
        suggestedProducts: [],
        homePageContents: null,
        banners: [] , 
        baseInfo: null,
        homeMetaDescriptions: null,
        redirectPages:[],
        //==============================================  
        userFullName: '',
        mobNo : '' ,
        //==============================================
        confirm: {
            confirmationCodeHashId: '',
            userName:'',
            timeRemaningForExpire: 0
        },
        //==============================================
        cart: null,
    },

    getters: {
        //============================================== 
        readBlogs: state => {
            return state.blogs;
        },
        readGroups: state => {
           return state.groups;
        },
        readNavbarmenu: state => {
            return state.navbarmenu;
        },
        readSliders: state => {
            return state.sliders;
        },
        readRedirectPages: state => {
            return state.redirectPages;
        },
        readAmazingOffers: state => {
            return state.amazingOffers;
        },
        readPromoSectionProducts: state => {
            return state.promoSectionProducts;
        },
        readHomePageContents: state => {
            return state.homePageContents;
        },
        readBrands: state => {
            return state.brands;
        },
        readSuggestedProducts: state => {
            return state.suggestedProducts;
        },
        readBaseInfo: state => {
            return state.baseInfo;
        },
        readHomeMetaDescriptions: state => {
            return state.homeMetaDescriptions;
        },
        //============================================== 
        readUserFullName: state => {
            return state.userFullName;
        },
        readUserMobNo: state => {
            return state.mobNo;
        },
        //==============================================
        readConfirm: state => {
            return state.confirm;
        },
        //===============================================
        readCart: state => {
            return state.cart
        }, 
        readBanners: state => {
            return state.banners
        }
    },
    mutations: {
        //============================================== 
        setHomePageContents: (state, data) => {
            state.homePageContents = data;
            state.groups = data.Groups;
            state.blogs = data.Blogs;
            state.navbarmenu = menuCreator(state.groups);
            state.sliders = data.Sliders;
            state.redirectPages = data.RedirectPages;
            state.amazingOffers = data.AmazingOffers;
            state.promoSectionProducts = data.PromoSectionProducts;
            state.brands = data.Brands;
            state.suggestedProducts = data.SuggestedProducts;
            state.userFullName = data.CustomerFullName;
            state.mobNo = data.MobileNo;
            state.banners = data.Banners, 
            state.baseInfo = data.BaseInfos;
            state.homeMetaDescriptions = data.HomeMetaDescriptions;

            if (data.IsUserLogined == false)
                localStorage.removeItem('accessToken');
        },
        //============================================== 
        setUserFullName: (state, data) => {
            state.userFullName = data;
        },
        //==============================================
        setConfirm: (state, data) => {
            state.confirm.confirmationCodeHashId = data.HashId;
            state.confirm.timeRemaningForExpire = data.RemainingTimeToExpire;
            state.confirm.userName = data.UserName;
        },
        //==============================================
        setCart: (state, data) => {
            state.cart = data;
        }
        //==============================================
    }
});